import { useEffect,useState } from "react";
import {Table,Modal,DatePicker,Input,Button,Col,
  Row,Form,Empty,Typography,Select,Checkbox} from "antd";
import { SearchOutlined,FileSyncOutlined,CalendarFilled} from "@ant-design/icons";
import axios from "axios";
import {src,path} from "../network/conn";
import moment from "moment";
import "../css/report.css";
function Paymentreport(props){
    const [employeeDetails, setemployeeDetails] = useState([]);
    const [paymentDetails, setpaymentDetails] = useState([]);
    const [patientDetails, setpatientDetails] = useState([]);
    const [loadingTaxReport,setLoadingTaxReport]=useState(false); 
    const [visibleTax,setVisibleTax]=useState(false);
    const [taxReportData, setTaxReportData] = useState([]);
    const [FilterData, setFilterData] = useState([]);
  const [invoiceMethod, setinvoiceMethod] = useState(false);
  const [userSetting,setUserSetting] = useState({});
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const {Option}=Select;
 var handleExcel = (function() {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns=""><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  return function(table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
    window.location.href = uri + base64(format(template, ctx))
  }
})()
 const reportDateFetch=()=>{
    //  let patient = form.getFieldValue('patient');
    //  let employee =  form.getFieldValue('employee');
     let payment =  form.getFieldValue('payment');
   let dateVal = form.getFieldValue('date');
   console.log(dateVal);
   let fromDate = dateVal!=undefined?moment(dateVal[0]).format("YYYY-MM-DD"):"-";
   let toDate = dateVal!=undefined?moment(dateVal[1]).format("YYYY-MM-DD"):"-";
   console.log(fromDate,toDate);
  let BaseURL = path + src + `fetch_full_payment_report.php?&&fromdate=${fromDate}&&todate=${toDate}&&payment=${payment}`;
  axios
  .get(BaseURL)
  .then((response) => {
      setVisibleTax(true);
    setTaxReportData(response.data);
    setFilterData(response.data);
  })
  .catch((error) => console.log(error));
 }
 const handleGst=(e)=>{
if(e.target.checked==true)
{
    console.log("hai");
 let filterValue = FilterData.filter((list)=>{ return list.method!='est'});
 setFilterData(filterValue);
 console.log(filterValue);
}
if(e.target.checked==false)
{
    setFilterData(taxReportData);
}
 }
 const fetchEmployeeList = () => {
      let BaseURL = path + src + "employeelist.php";
      axios
        .get(BaseURL)
        .then((response) => {
          setemployeeDetails(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
  };
  const fetchPaymentDetails = () => {
    let BaseURL = path + src + "paymentlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setpaymentDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
};
const fetchPatientDetails = () => {
    let BaseURL = path + src + "patientlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setpatientDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
};
 const closeModalPro=()=>{
  setVisibleTax(false);
  document.getElementById('reportHeading').innerHTML="";
  form.resetFields();
 }
 const profile = window.sessionStorage.getItem("profile");
 const fetch_profile_permission = (profile) =>{
   console.log('profile',profile);
   let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
   axios
   .get(BaseURL)
     .then((response) => {
       console.log(response.data);
       let dataObj = {};
       response.data.map((list)=>{
         let permissionObj = {};
         if(list.filename == 'paymentreport'){
         permissionObj['add']      = list.add;
         permissionObj['edit']     = list.edit;
         permissionObj['delete']   = list.delete;
         permissionObj['show']     = list.show;
         permissionObj['print']    = list.print;
         permissionObj['excel']    = list.excel;
         permissionObj['profile']  = list.profile;
         dataObj[list.filename]    =  permissionObj;
         setUserSetting(permissionObj);
         }
       })
      
      console.log('dataObj',dataObj);
     })
     .catch((error) => {
       //openMessageSuccess(error, 10);
       console.log(error);
     });
   }
    useEffect(()=>{
      fetch_profile_permission(profile);
        fetchEmployeeList();
        fetchPaymentDetails();
        fetchPatientDetails();
    },[]);
    
    const taxReportColumn=[
      {
      key:"1",
      title:"Sno",
      dataIndex:"id",
  },
  {
    key:"2",
    title:"Date",
    dataIndex:"date",
},
  {
    key:"3",
    title:"Time",
    dataIndex:"time",
},
  {
      key:"4",
      title:"Code",
      dataIndex:"code",
  },
  {
    key:"5",
    title:"PT Id / EMP Id",
    dataIndex:"patient",
    filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              autocomplete="off"
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.patient.toLowerCase().includes(value.toLowerCase());
      },
},
  {
    key:"6",
    title:"PT Name / EMP Name",
    dataIndex:"patientname",
    filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              autocomplete="off"
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.patientname.toLowerCase().includes(value.toLowerCase());
      },
},
{
    key:"10",
    title:"Payment",
    dataIndex:"payment",
},
  {
      key:"7",
      title:"Scan Amount",
      dataIndex:"scanamount",
  },
  {
    key:"8",
    title:"Expense Amount",
    dataIndex:"expenseamount",
},
{
    key:"9",
    title:"Method",
    dataIndex:"method",
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <>
          <Input
            autocomplete="off"
            placeholder="Type To Search"
            autoFocus
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onBlur={() => {
              confirm({ closeDropdown: false });
            }}
          ></Input>
        </>
      );
    },
    filterIcon: () => {
      return <SearchOutlined />;
    },
    onFilter: (value, record) => {
      return record.method.toLowerCase().includes(value.toLowerCase());
    },
},

    ]
    
    return (<div className="reportTabe">
      <Modal 
          title={<div>REPORT <span>{Number(userSetting.excel) == 1 ? <Button type="danger" className="Excel" onClick={()=>handleExcel('ExcelReport','Payment REPORT')}>EXCEL</Button> : ''}</span></div>}
        style={{ top: 20 }}
        visible={visibleTax}
        onOk={closeModalPro}
        onCancel={closeModalPro}
        className="fullModal"
        footer={null}
        maskClosable={false}>
         
            <div id="ExcelReport">
            <h3 id="reportHeading"></h3>
           
        <Table
        dataSource={FilterData}
        columns={taxReportColumn}
        pagination={false}
        loading={loadingTaxReport}
        summary={(tableData) => {
            let taxValue=0;
            let eighteenTax = 0;
            let taxTotal= 0;
            let discount =0;
            tableData.map((tableData)=>{ 
                discount+=Number(tableData.scanamount);
                taxTotal+=Number(tableData.expenseamount);})
            return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={6} />
                <Table.Summary.Cell colSpan={1}>
                  Total
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={1}>
                  <Typography
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                  >
                   {discount.toFixed(2)}
                  </Typography>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={1} align="center">
                  <Typography
                    style={{ fontSize: "18px", fontWeight: "bold"  }}
                  >
                   {taxTotal.toFixed(2)}
                  </Typography>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={1} align="center">
                  <Typography
                    style={{ fontSize: "18px", fontWeight: "bold"  }}
                  >
                   Balance : {discount.toFixed(2)!= 0.00 ? discount.toFixed(2)-taxTotal.toFixed(2) : 0.0}
                  </Typography>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          ); }}
      ></Table>
      
        </div>
      </Modal>
      <h2>Report</h2>
        <Form layout="vertical" form={form} >
          <Row gutter={24}>
             
              {/* <Col span={4}>
              <Form.Item
                  name="Employee"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Employee"
                  >
                    {employeeDetails.map((list) => (
                      <Option value={list.employeecode}>
                        {list.employeename}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}
              <Col span={6}>
              <Form.Item
                  name="payment"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Payment"
                  >
                    {paymentDetails.map((list) => (
                      <Option value={list.code}>
                        {list.payment}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col span={4}>
              <Form.Item
                  name="patient"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Patient"
                  >
                    {patientDetails.map((list) => (
                      <Option value={list.patientid}>
                        {list.patientname}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}
            <Col span={8}>
              <Form.Item
                name="date"
              >
                <RangePicker style={{width:"100%"}}/>
              </Form.Item>
            </Col>
            <Col span={2}>
              <Form.Item
               name="submit"
                //rules={[{ required: true, message: "Please enter user name" }]}
              >
                <Button type="primary" onClick={reportDateFetch}><CalendarFilled /></Button>
              </Form.Item>
            </Col>
            </Row>
            </Form>
            <Empty
    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
    imageStyle={{
      height: 60,
    }}
    className="emptyContent"
    description={
      <span>
        Use Above Filters To Fetch Report
      </span>
    }
  >
  </Empty>,
    
    </div>)
}
export default Paymentreport;